import { render, staticRenderFns } from "./costTypeAdd.vue?vue&type=template&id=38981bd1&scoped=true"
import script from "./costTypeAdd.vue?vue&type=script&lang=js"
export * from "./costTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./costTypeAdd.vue?vue&type=style&index=0&id=38981bd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38981bd1",
  null
  
)

export default component.exports